var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_1058)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.3147,
    cy: 20.7122,
    r: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2711 12.4006C34.1649 10.6075 30.1928 11.673 28.3977 14.7793L23.8727 22.6178C22.5634 24.8814 24.249 25.6723 26.1285 26.7992L30.4826 29.3123C31.9571 30.1628 33.8404 29.6579 34.6909 28.1854L39.3426 20.1298C40.9054 17.4228 39.9781 13.9633 37.2711 12.4006Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1499 15.6453L27.7958 13.1323C25.3922 11.798 24.0311 11.7097 23.0442 13.2782L16.6225 24.3997C14.8293 27.5041 15.8968 31.4743 19.0011 33.2636C21.708 34.8263 25.1676 33.899 26.7303 31.1921L33.275 19.8555C34.1293 18.3811 33.6244 16.4958 32.1499 15.6453Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.989 9.92792L29.9307 8.16169C26.548 6.20922 22.2226 7.36688 20.2702 10.7496L14.4473 20.8344C13.5873 22.3223 14.0979 24.2267 15.5858 25.0849L19.0108 27.0623C20.7021 28.0396 22.8638 27.4597 23.841 25.7684L30.4932 14.2475C31.8717 11.8612 34.9223 11.0433 37.3086 12.4218L32.989 9.92792Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0974 13.635L17.7915 11.7306C16.317 10.882 14.4337 11.385 13.5832 12.8556L9.61689 19.7094C7.66442 23.0825 8.82208 27.3983 12.2048 29.345L14.7217 30.7944L17.7742 32.5529L19.0989 33.3151C16.7471 31.7409 16.0003 28.5866 17.4382 26.1023L18.4653 24.3284L22.2263 17.8298C23.0748 16.3631 22.5699 14.4836 21.0974 13.635Z",
    fill: "#4285F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_1058",
    x: 0.314697,
    y: 0.712158,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_1058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_1058",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.8242a269385be4e92f784e3f223de8f5.svg";
export { ForwardRef as ReactComponent };